<template>
  <div class="page_report_top page_date_top">
    <div class="topNav">
      <div class="dateSelect">
        <div>
          <ShowNavHead />
        </div>
        <div class="exact_box mr10">
          <div class="d_txt">起止日期:</div>
          <div class="d_box" v-if="activeName!='JBreportKFyear' && activeName!='JBreportKFemp'">
            <el-date-picker v-model="listQuery.dtDatestart" size="small" type="date" placeholder="开始日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
            <span class="re_txt">-</span>
            <el-date-picker v-model="listQuery.dtDateend" size="small" type="date" placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
          </div>
          <div class="d_box" v-if="activeName=='JBreportKFemp'">
            <el-date-picker v-model="listQuery.start" size="small" type="date" placeholder="开始日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
            <span class="re_txt">-</span>
            <el-date-picker v-model="listQuery.end" size="small" type="date" placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
          </div>
          <div class="d_box" v-if="activeName == 'JBreportKFyear'">
            <el-date-picker v-model="listQuery.start" size="small" type="month" placeholder="开始日期" :picker-options="pickerOptions" format="yyyy-MM" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
            <span class="re_txt">-</span>
            <el-date-picker v-model="listQuery.end" size="small" type="month" placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM" value-format="yyyy-MM-dd" :clearable="false"></el-date-picker>
          </div>
        </div>
        <el-select v-model="listQuery.projectid" size="small" filterable clearable placeholder="请输入或选择项目名称" style="width: 180px;" @change="projectChange" v-if="activeName!='JBreportKFemp'">
          <el-option v-for="(item, index) in projectList" :key="index+'d'" :label="item.StrprojectName" :value="item.Projectid">
          </el-option>
        </el-select>
        <el-select v-model="listQuery.projectid" size="small" filterable clearable placeholder="请输入或选择项目名称" style="width: 180px;" v-if="activeName=='JBreportKFemp'">
          <el-option label="全部" :value="0">
          </el-option>
          <el-option v-for="(item, index) in projectList" :key="index+'d'" :label="item.StrprojectName" :value="item.Projectid">
          </el-option>
        </el-select>
        <div class="screenInput cp" style="margin: 0 0 0 10px;" v-if="activeName!='JBreportKFyear'">
          <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
            <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
          </el-tooltip>
        </div>
        <button class="exportButton" style="margin-left:5px" @click="searchEnterFun" v-show="showDropScreen!=1">搜索</button>
      </div>
      <div class="screenAndExport">
        <div>
          <el-button class="exportButton" style="margin-right:20px" :loading="btnLoading" @click="exportTable" :disabled="listData.length==0">导出</el-button>
          <!-- <el-button v-if="pathname == 'report'" class="exportButton" style="margin-right:20px" :loading="btnLoading" @click="exportInfo" :disabled="(listData==[]||listData.length<=0)">导出</el-button>
          <el-button v-if="pathname == 'recruit'" class="exportButton" style="margin-right:20px" :loading="btnLoading" @click="exportInfo" :disabled="(listData==[]||listData.length<=0)">导出</el-button> -->
        </div>
      </div>
      <div class="dropDownScreen" v-show="showDropScreen==1 && activeName!='JBreportKFyear'">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" class="pro_down_form" label-width="120px">
            <el-form-item label="服务中心:">
              <el-select v-model="listQuery.strDep2" filterable clearable placeholder="">
                <el-option v-for="(item, index) in departList" :key="index+'f'" :label="item.StrDep2Name" :value="item.StrDep2">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目状态:" prop="strBusiStat">
              <el-select v-model="listQuery.strBusiStat" placeholder="" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="合作中" value="合作中"></el-option>
                <el-option label="已暂停" value="已暂停"></el-option>
                <el-option label="已终止" value="已终止"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客服:">
              <el-select v-model="listQuery.strservuserid" filterable clearable placeholder="">
                <el-option v-for="(item, index) in customerList" :key="index+'d'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合伙人:">
              <el-select v-model="listQuery.strpartner2" filterable clearable placeholder="">
                <el-option v-for="(item, index) in partnerList" :key="index+'a'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业绩归属人:">
              <el-select v-model="listQuery.strAchieveowner" filterable clearable placeholder="">
                <el-option v-for="(item, index) in partnerList" :key="index+'c'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型:">
              <el-select v-model="listQuery.actualtype" filterable clearable placeholder="">
                <el-option v-for="(item, index) in businessList" :key="index+'c'" :label="item.StrBusitypeName" :value="item.Busitypeid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推荐渠道:">
              <el-select v-model="listQuery.PushName" filterable clearable placeholder="">
                <el-option value="宁波网招"></el-option>
                <el-option value="社招推荐人"></el-option>
                <el-option value="网招中心"></el-option>
                <el-option value="公司渠道"></el-option>
                <el-option value="校招部"></el-option>
                <el-option value="业务项目部"></el-option>
                <el-option value="招聘部"></el-option>
                <el-option value="客服部"></el-option>
                <el-option value="小杰门店"></el-option>
                <el-option value="企业转移"></el-option>
                <el-option value="员工内荐"></el-option>
                <el-option value="供应商"></el-option>
                <el-option value="其他情况"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="在/离职状态:" v-if="activeName=='JBreportKFemp'">
              <el-select v-model="listQuery.StrWorkState" filterable clearable placeholder="">
                <el-option label="全部" value=""></el-option>
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
          <button class="reset" @click="resetForm()">清空</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
          <button class="exportButton" style="margin-left:10px" @click="searchEnterFun">搜索</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    parseTime
  } from '@/utils' //格式化时间格式
  export default {
    props: {
      listData: {
        type: Array // 定义接收到的数据的类型
      },
      pathname: {
        type: String // 是哪个页面的'report'
      },
      listQuery: {
        type: Object
      },
      listQuery2: {
        type: Object
      },
      activeName: {
        type: String
      }
    },
    components: {
      parseTime
    },
    data() {
      return {
        hasRefresh: false, //刷新按钮
        roletype: localStorage.loginRoletype,
        weekNum: "",
        weekVal: "",
        isActive: 2,
        date: null,
        showMonthOrYear: "",
        btnLoading: false,
        //下拉筛选
        showDropScreen: -1,
        //导出
        dialogVisible4: false,
        dateTypeSelect: [{
            name: "日",
            value: 3
          },
          {
            name: "周",
            value: 2
          },
          {
            name: "月",
            value: 1
          }
          // {
          //   name: "自定义日期",
          //   value: 4
          // }
        ],
        // 参数列表参数
        paramQuery: {
          currpage: 1,
          perpage: 100000,
          keyword: '',
          strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
          // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级 
          // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
          strtableid: ''
        },
        dedpartNameList: '',
        businessList: [],
        // 部门列表
        departList: [],
        // 自定义 级联选择props
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        query: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: ""
        },
        customerList: [],
        partnerList: [],
        projectList: [],
        exportQuery: {},
        // 项目参数
        projectQuery: {
          projectname: '', // 项目名称
          projectid: '', // 项目id
          custname: '', //客户名称
          strbusdep: '', //业绩归属部门
          strpartner2: '', //合伙人
          strDep1: '', //部门一级
          strDep2: '', //部门二级
          strDep3: '', //部门三级
          strservuserid: '', //客服
          strContractType: '', //合同业务类型
          actualtype: '', //实操业务类型
          strSignsubject: '', //签约主体
          socialInsurance: '', //社保
          busInsurance: '',
          strProProvince: '', //省份
          strProCity: '', //城市
          strBillmethod: '', //发票类型
          strinvoiceType: '', //开票方式
          strprojectlevel: '', //项目等级
          groupname: '', //所属集团名称
          strBusiStat: '', //项目状态
          perpage: 10000000,
          currpage: 1,
          strorgancode: localStorage.gancode,
          roletype: localStorage.loginRoletype,
          strpartner: '', // 团队长
          dtInitDatestart: '', // 立项开始时间
          dtInitDateend: '', // 立项结束时间
          strAchieveowner: '', // 业绩归属人
          strAchievedep: '' //业绩归属人部门
        },
        permissionLists: [],
        //禁用日期范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        //禁用日期范围周
        pickerOptionsWeek: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000 * 7;
          },
          'firstDayOfWeek': 1
        },
        //禁用日期范围月
        pickerOptionsMonth: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000 * 31;
          }
        },
        //选择的type名称
        dateTypeName: '月'
      };
    },
    async created() {
      let endDate = moment().format("YYYY-MM-DD");
      let nowdate = moment().subtract(7, 'days').format("YYYY-MM-DD"); // 7天前
      this.listQuery.dtDatestart = nowdate
      this.listQuery.dtDateend = endDate
      this.$emit('fatherMethod', this.listQuery);
      this.getProjectList()
      //   let tab = JSON.parse(localStorage.tableids);
      //   if (tab && tab != undefined && tab.length > 0) {
      //     tab.forEach((element, index) => {
      //       element.Strroletable = element.Strroletable + '2';
      //       if (element.StrroleName == '利润表刷新') {
      //         this.hasRefresh = true;
      //       }
      //     });
      //   }
    },
    methods: {
      checkPermission,
      //搜索
      searchEnterFun() {
        this.showDropScreen = -1;
        this.listQuery.currpage = 1;
        // this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      //清空
      resetForm() {
        this.listQuery = this.$options.data.call(this).listQuery;
        this.listQuery.roletype = localStorage.loginRoletype;
        this.listQuery.currpage = 1;
        let endDate = moment().format("YYYY-MM-DD");
        let nowdate = moment().subtract(7, 'days').format("YYYY-MM-DD"); // 7天前
        this.listQuery.dtDatestart = nowdate;
        this.listQuery.dtDateend = endDate;
      },
      exportInfo() {
        this.btnLoading = true;
        let data = JSON.parse(JSON.stringify(this.$parent.listQuery)) //拷贝
        this.$set(data, 'currmon', '');
        this.$set(data, 'currpage', 1);
        this.$set(data, 'perpage', 10000000);
        this.$set(data, 'tableid', 'JBreportKF');
        xz.outputResumeList('5', data).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: '/effExportList'
            })
          } else {
            this.$message({
              message: "导出错误",
              type: "error"
            })
          }
          this.btnLoading = false;
        })
      },
      exportTable() {
        this.btnLoading = true;
        if (this.activeName != 'JBreportKFemp') {
          let d = JSON.parse(JSON.stringify(this.listQuery))
          d.perpage = 1000000;
          xz.outReportExcel(this.activeName, d).then(res => {
            if (res.status == 'ok') {
              this.$router.push({
                path: '/effExportList',
                query: {
                  type: 'report',
                  isReport: 'true',
                  showPage: 1,
                  isActive: 1,
                  custname: res.msg,
                  //qStstus=1时查看最后一条导出记录
                  qStstus: 1
                }
              })
            } else {
              this.$message({
                message: "导出错误",
                type: "error"
              })
            }
            this.btnLoading = false;
          })
        } else {
          let d = {
            "userid": Cookies.get("userid-b"),
            "start": moment().subtract(7, 'days').format("YYYY-MM-DD"),
            "end": moment().format("YYYY-MM-DD"),
            "projectid": this.listQuery.projectid ? this.listQuery.projectid : 0,
            "strDep2": this.listQuery.strDep2,
            "strBusiStat": this.listQuery.strBusiStat,
            "strservuserid": this.listQuery.strservuserid,
            "strpartner2": this.listQuery.strpartner2,
            "strAchieveowner": this.listQuery.strAchieveowner,
            "actualtype": this.listQuery.actualtype,
            "pushName": [],
            "strWorkState": '',
            filename: '入离职人员明细统计导出列表.xlsx',
          }
          xz.rcExpFun(d, 'InterviewOnboarding/ReportJoiningLeavingDetails/download').then(res => {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = '入离职人员明细统计导出列表.xlsx';
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.btnLoading = false;
            } catch (e) {
              this.btnLoading = false;
              this.$message.error('导出异常')
            }
          })
        }

      },
      // 选择项目
      projectChange(val) {
        let obj = {};
        let that = this
        if (val) {
          obj = that.projectList.find((item) => {
            return item.Projectid === val;
          });
          that.listQuery.projectname = obj.StrprojectName;
        } else {
          that.listQuery.projectname = ''
          that.listQuery.projectid = ''
        }
      },
      // 获取项目列表
      getProjectList() {
        xz.getProjectLists(this.projectQuery).then(res => {
          // console.log('客户', res)
          if (res.status == 'ok') {
            this.projectList = res.msg
          } else {
            this.projectList = []
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
          if (this.customerList.length == 0) {
            // 获取部门列表
            this.getCenterList();
            // 客服
            this.getScreenList('getrecrrservicesr', 'customerList');
            // 合伙人
            this.getMemberList();
            this.getParamList('JB_base_Busitype')
          }
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 获取部门列表
      getScreenList(pagename, list) {
        xz.getrecrrservicesdepart(pagename, '0383e791-72fd-4edc-aa70-2bcadminuser').then(res => {
          if (res.status == 'ok') {
            this[list] = res.data;
          } else {
            this[list] = [];
          }
        })
      },
      // 获取参数列表(等级)
      getParamList(type) {
        this.paramQuery.strtableid = type
        xz.getParameterList(this.paramQuery).then(res => {
          // console.log('参数', res)
          if (res.status == 'ok') {
            if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = res.msg
            }
          } else {
            if (type == 'JB_base_Busitype') {
              // 业务类型
              this.businessList = []
            }
          }
        })
      },
      // 获取服务中心
      getCenterList() {
        let query = {
          currpage: 1,
          perpage: 100000,
          strDep2: ''
        }
        xz.getReportProDep2(query).then(res => {
          // console.log('33',res)
          if (res.status == 'ok') {
            this.departList = res.msg;
          } else {
            this.departList = [];
          }
        })
      },
      //取合伙人列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.query).then(res => {
          if (res.status == 'ok') {
            this.partnerList = res.msg;
          } else {
            this.partnerList = []
          }
        })
      },
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .screenAndExport{
   margin-right: 50px;
 } */
  /* .page_date_top .dateSelectNav {
    width: 212px;
  } */
  .exact_box {
    display: flex;
    align-items: center;
  }

  .d_txt {
    width: 76px;
    font-size: 14px;
  }

  .d_box {
    display: flex;
    align-items: center;
  }

  .mr10 {
    margin-right: 10px;
  }

  .page_date_top .el-date-editor--daterange.el-input__inner {
    width: 235px !important;
    margin-right: 5px;
  }

  .page_date_top .el-date-editor .el-range__close-icon {
    display: none;
  }

  .page_date_top .el-date-editor.el-input {
    width: 170px;
  }

  .top-right {
    display: flex;
    align-items: center;
  }

  .top-right .el-button--text {
    padding: 7px 10px;
    border: solid 1px #19BD92;
    font-size: 12px;
    color: #19BD92;
    border-radius: 4px;
    background-color: #fff;
  }

  .top-right .el-button--text img {
    vertical-align: sub;
  }

  .reset {
    height: 32px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #B2BCB7;
    background-color: #fff;
    border: 1px solid #B2BCB7;
    margin-right: 10px;
  }

  .screenAndExport .exportButton {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #19BD92;
    border: 1px dashed #19BD92;
    color: #fff;
  }

  .screenAndExport {
    align-items: center;
    -webkit-align-items: center;
  }

  .pro_down_box {
    padding-top: 15px;
  }

  .re_txt {
    margin: 0 5px;
  }
</style>

<style>
  .page_report_top .el-form-item {
    margin-bottom: 3px;
  }

  .titleAndButton .exportButton {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #19BD92;
    border: 1px dashed #19BD92;
    color: #fff;
  }

  .exactDate {
    display: flex;
    align-items: center;
  }

  .sels-box .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  .exactDate .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  .exactDate .el-input__icon {
    line-height: 32px;
  }

  .sels-box .el-input__icon {
    line-height: 32px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .screenAndExport .el-button {
    padding: 0;
    margin-right: 20px;
  }

  .dialog .el-dialog__header {
    padding: 0;
  }

  .dialog .el-dialog__body {
    padding: 20px 20px 0 20px;
  }

  .storageInput .el-input--small .el-input__inner {
    width: 368px;
    height: 32px;
  }

  .storageInput .el-input--small {
    width: 360px;
  }

  .pro_down_box .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .ssdate .el-input--suffix .el-input__inner {
    padding-right: 10px;
  }
</style>